import { useSpring, useVelocity } from 'framer-motion';
import { useEffect, useState } from 'react';

const useNumberTransform = (
  value = 100,
  { springOpts = {}, integer = true, animate = true, cb, decimals = 2 } = {}
) => {
  const [num, setNum] = useState(0);
  const x = useSpring(0, { duration: 3000, ...springOpts, bounce: 0 });

  useEffect(() => {
    x.onChange(() => {
      setNum(x.get());
      if (
        (x.get() === value ||
          (!integer &&
            (Number(x.get().toFixed(decimals)) === value ||
              Number(x.get().toFixed(decimals)) + 1 / (10 * decimals) ===
                value))) &&
        cb &&
        typeof cb === 'function'
      )
        cb(x.get());
    });
  }, [cb, decimals, integer, value, x]);

  useEffect(() => {
    if (animate) {
      x.set(value);
    }
  }, [animate, value, x]);

  const processNumber = num => {
    if (integer) num = Math.floor(num);
    return num;
  };

  return [processNumber(num), x];
};

export default useNumberTransform;
